export {
  extendEventWithGraphQLResourceData,
  isGraphQLResource,
} from './extendEventWithGraphQLResourceData';
export { shouldExcludeResourceFromPageLoadActivity } from './shouldExcludeResourceFromPageLoadActivity';
